import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Card, CardContent, CardHeader, Divider, Typography, } from "@mui/material";
import { PlayerView } from "../players/PlayerView";
export var SquadCard = function (_a) {
    var title = _a.title, _b = _a.action, action = _b === void 0 ? undefined : _b, players = _a.players;
    return (_jsxs(Card, { children: [_jsx(CardHeader, { title: title, action: action }), _jsxs(CardContent, { children: [_jsx(Divider, { sx: { marginBottom: 2 } }), players.length === 0 ? (_jsx(Typography, { variant: "body2", textAlign: "center", color: "text.secondary", sx: { py: 2 }, children: "No players!" })) : (players.map(function (player, index) { return (_jsx(Box, { sx: {
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                            px: 2,
                            py: 1,
                            bgcolor: index % 2 === 0 ? "white" : "#f9f9f9",
                            borderRadius: 1,
                        }, children: _jsx(PlayerView, { player: player, variant: "subtitle1" }) }, player.id)); }))] })] }));
};
